import { render, staticRenderFns } from "./_wp.vue?vue&type=template&id=57b59720&scoped=true"
import script from "./_wp.vue?vue&type=script&lang=ts"
export * from "./_wp.vue?vue&type=script&lang=ts"
import style0 from "./_wp.vue?vue&type=style&index=0&id=57b59720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b59720",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/usr/src/app/components/Header.vue').default,Company: require('/usr/src/app/components/blocks/Company.vue').default})
